import { render } from "./paymentSummary.vue?vue&type=template&id=b9ed9404&scoped=true&ts=true"
import script from "./paymentSummary.vue?vue&type=script&lang=ts"
export * from "./paymentSummary.vue?vue&type=script&lang=ts"

import "./paymentSummary.vue?vue&type=style&index=0&id=b9ed9404&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ed9404"]])

export default __exports__